export class AppFunctionGroupMap {
	appFunctionId: number;
	appFunctionGroupId: number;
    id: number;
    readOnly: boolean;
}
